import type { RefObject } from "react"

import { useEffect, useState } from "react"

export const useIntersectionObserver = (
  ref: RefObject<HTMLElement | null>,
  options: IntersectionObserverInit = {}
): boolean => {
  const [isObserved, setIsObserved] = useState(false)

  useEffect(() => {
    const onObserve: IntersectionObserverCallback = entries => {
      for (const entry of entries) {
        if (entry.isIntersecting) {
          setIsObserved(true)
          return
        }
      }
    }

    const observer = new IntersectionObserver(onObserve, options)
    const element = ref.current

    if (element) {
      observer.observe(element)
    }

    return () => {
      if (element) {
        observer.unobserve(element)
      }
    }
  }, [ref, options])

  return isObserved
}
